import { find, get, head } from "lodash";
import { MDBSpinner } from "mdbreact";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import { resetSelectDate } from "~/store/dateAndSpecialist/dateAndSpecialistActions";
import {
  changeDirection,
  changeServiceType,
  getBookingTree,
  goBackStep,
  resetListNode,
  selectService
} from "~/store/totalData/actions";
import { SERVICE } from "~/utils/constants";
import { getPartnerFromUrl } from "~/utils/func";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const ChooseServiceDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/Schedules/ChooseService"),
  loading: LoadableLoading
});
class ChooseService extends Component {
  methods = {
    handleGoBack: () => {
      this.props.goBackStep("service");
    },
    handleChooseService: service => {
      this.props.selectService(service);
    }
  };

  componentDidMount() {
    const {
      serviceList,
      isDirectionBack,
      selectService,
      resetListNode,
      getBookingTree
    } = this.props;

    if (serviceList.length === 0) {
      const currentPagePartnerId = getPartnerFromUrl(
        this.props.history.location.pathname
      );
      getBookingTree("", currentPagePartnerId);
    }

    resetListNode(SERVICE);

    if (serviceList.length === 1) {
      const service = head(serviceList);
      const serviceType = get(service, "detail.serviceType");
      if (serviceType !== "BOTH") {
        if (isDirectionBack) {
          this.methods.handleGoBack();
        } else {
          selectService(service);
        }
      }
    }
  }

  render() {
    const { serviceList } = this.props;

    if (!serviceList) {
      return (
        <div className="loading">
          <MDBSpinner big />
        </div>
      );
    }

    if (serviceList.length === 0) {
      return (
        <div className="loading">
          <MDBSpinner big />
        </div>
      );
    }

    return (
      <React.Fragment>
        <ChooseServiceDesktop {...this.props} {...this.methods} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    dateAndSpecialist: {
      selectedSpecialist: { id: selectedSubjectId }
    },
    hospital: { selectedHospital },
    rebooking: { rebookingSelected },
    totalData: {
      service: {
        list: serviceList,
        id: serviceId,
        subType: subtypeService,
        serviceType: selectedServiceType
      },
      service: selectedServiceObject,
      listNode,
      isDirectionBack,
      partnerId
    }
  } = state;
  const { service } = state.totalData;
  return {
    device: type,
    selectedSubjectId,
    selectedHospital,
    rebookingSelected,
    serviceList,
    serviceId,
    subtypeService,
    listNode,
    service,
    isDirectionBack,
    partnerId,
    selectedServiceType,
    selectedServiceObject
  };
};

const ChooseServiceHelmet = withTitle({
  component: ChooseService,
  title: `${hospitalName.value} | Chọn dịch vụ`
});

export default connect(mapStateToProps, {
  resetSelectDate,
  selectService,
  changeDirection,
  changeServiceType,
  resetListNode,
  goBackStep,
  getBookingTree
})(ChooseServiceHelmet);
